import React from "react";
import DaysLeftCounter from "../../../components/DaysProgress";
import CustomChip from "../../../components/Chip";
import ExpenseComponent from "../view/ExpenseDetails";
import LiveStatus from "../view/Livestatus";
import ContainerVehicleDetails from "../view/container";
import DeliveryTimeline from "../../../components/DeliveryTimeline";
import SecureImage from "../../../components/BucketImage/Image";
import moment from "moment";
import { useNavigate } from "react-router-dom";

interface TripData {
  tripId: string;
  bookingId: string;
  bookingDate: string;
  bookingName: string;
  daysLeft: number;
  endingDateTime: string;
  startingDateTime: string;
  tripName: string;
  tripNumber: string;
  tripStatus?: string;
}

interface AllBookingProps {
  viewTripDetails: boolean;
  truck: string;
  images: string[];
  tripCard: number | null;
  tripData: TripData[] | null;
activeTripCard: number | null;
}

const Booking: React.FC<AllBookingProps> = ({
  viewTripDetails,
  truck,
  images,
  tripCard,
  tripData,
}) => {
  // Get the active trip data based on tripCard index
  const navigate = useNavigate();
  const trip =
    tripCard !== null && tripData ? tripData[tripCard] : null;

  return (
    <>
      {viewTripDetails && trip && (
        <div className="flex flex-col w-full border-l border-[#C1C1C1] border-dashed">
          <div className="flex justify-between w-full p-2">
            <div className="flex items-center space-x-2">
              <SecureImage fileKey={truck} alt="booking" width="60px" />
              <div>
                <div className="flex items-center space-x-2">
                  <button onClick={()=>navigate(`/trip/view/trip/${trip.tripId}`)} className="text-[#444FBD] text-[16px] leading-[30px] font-[600]">
                    {trip.tripName}
                  </button>
                  <CustomChip
                    text={trip.tripStatus || "Ongoing"}
                    backgroundColor="#FFF5EC"
                    textColor="#FFB470"
                    borderColor="#FFB470"
                  />
                </div>
                <p className="text-[14px] leading-[20px] font-[400]">
                  #{trip.tripNumber}
                </p>
                <p className="text-[14px] leading-[20px] font-[400]">
                  {moment(trip.startingDateTime).format(
                    "DD MMMM YYYY, hh:mma"
                  )}
                </p>
              </div>
            </div>
            <div className="flex justify-end">
              <div className="flex flex-col items-end gap-1">
                <div className="flex items-center gap-1">
                  <DaysLeftCounter totalDays={trip.daysLeft} />
                  <p className="text-[14px] leading-[20px] font-[400]">
                    Days left
                  </p>
                </div>
                <p className="text-[14px]">
                  {moment(trip.endingDateTime).format(
                    "DD MMMM YYYY, hh:mma"
                  )}
                </p>
              </div>
            </div>
          </div>

          <LiveStatus />
          {/* <ContainerVehicleDetails images={images} /> */}
          <div className="p-2">
            <p className="text-[16px] font-[600] leading-[30px]">
              Route Points
            </p>
            <DeliveryTimeline />
          </div>
          <ExpenseComponent />
        </div>
      )}
    </>
  );
};

export default Booking;
